import { createAction, props } from '@ngrx/store';

import { Manager } from '@shared/models';

export const managerLoadSuccess = createAction(
  '[Managers] Load Success',
  props<{ manager: Manager }>()
);

export const managerGet = createAction(
  '[Managers] Get',
  props<{ id: number }>()
);

export const managerLoadFailed = createAction(
  '[Managers] Load Failed',
  props<{ error?: any }>()
);
